import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useLines } from '@/hooks/v1';
import { LineSelect } from '@/components/ui/Inputs/LineSelect';
import { useApplicationContext } from '@/context/v1/Application/context';
import { LINE_FIELD, SECTOR_FIELD, WORKSTATION_FIELD } from './constants';
import { FieldFormItem } from './styles';

const { useFormInstance, useWatch } = Form;

export function Line(): JSX.Element {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const lineId = useWatch(LINE_FIELD, form);
	const sectorId = useWatch(SECTOR_FIELD, form);

	const {
		data: lines,
		isLoading,
		isFetching,
		isError
	} = useLines({
		organization_id: organization?.id,
		company_id: company?.id,
		sector_id: sectorId
	});

	function handleSelectLine(id?: string): void {
		form.setFieldValue(LINE_FIELD, id);
		form.setFieldValue(WORKSTATION_FIELD, undefined);
	}

	function handleClearLines(): void {
		handleSelectLine(undefined);
	}

	const isDisabled = isLoading || isFetching || isError || !sectorId;

	return (
		<FieldFormItem name={LINE_FIELD} label={I18n.get('Line')} labelCol={{ span: 24 }}>
			<LineSelect
				lines={lines}
				lineId={lineId}
				sectorId={sectorId}
				loading={isFetching}
				disabled={isDisabled}
				fieldName={LINE_FIELD}
				allowCreation={false}
				handleSelectLine={handleSelectLine}
				handleClearLines={handleClearLines}
			/>
		</FieldFormItem>
	);
}
